<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Map Module With Client</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected" (change)="onClientChange($event.target.selectedIndex)">
      <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="moduleSelected" (change)="onModuleChange($event.target.selectedIndex)">
        <option *ngFor="let module of modules" [value]="module.id">{{module.MODULENAME}}</option>
      </select>
    </div>
    <div class="form-group">
      <input [min]="min" [max]="max" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" class="form-control radius-0 font-13" [(ngModel)]="sDate" placeholder="Availability Date">
      <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
    </div>
    <mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"><b class="blue">Until Client is Active </b>
    </mat-slide-toggle>
    <div class="form-group" [hidden]="slideChecked">
      <input [min]="min" [max]="max" [owlDateTimeTrigger]="dt4" [owlDateTime]="dt4" class="form-control radius-0 font-13" [(ngModel)]="eDate" placeholder="Availability Until">
      <owl-date-time [pickerType]="'calendar'" #dt4></owl-date-time>
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="sequence"
             placeholder="Enter Menu Sequence greater than 0">
    </div>
    <!--<div class="form-group font-13">-->
      <!--<mat-checkbox [(ngModel)]="isChecked" >Auto Configure Menu</mat-checkbox>-->
    <!--</div>-->
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
